export const QUOTA_LOW_REMAINING_THRESHOLD = 3;

export const DATE_TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  dateStyle: "short",
  timeStyle: "short",
};

export const MILLISECONDS_PER_SECOND = 1000;
